import { NgModule } from '@angular/core';

import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';

import { sheetViewStateKey } from '../sheet-view-core/sheet-view.state';
import { tabControllerReducer } from '../sheet-view-core/store/option-group-tab-controller-index-keeper.reducer';
import { tabControllerStateKey } from '../sheet-view-core/store/option-group-tab-controller-index-keeper.state';
import { SheetViewEffects } from './sheet-view.effects';
import { sheetViewReducer } from './sheet-view.reducer';

@NgModule({
    imports: [
        StoreModule.forFeature(sheetViewStateKey, sheetViewReducer),
        EffectsModule.forFeature([SheetViewEffects]),
        StoreModule.forFeature(tabControllerStateKey, tabControllerReducer),
    ],
})
export class OptionSheetViewModule {}
